import React, { Component } from "react";
import VotingOpenHeader from "../../components/VotingOpenHeader/VotingOpenHeader";
import FilterableVideoList from "../../components/FilterableVideoList/FilterableVideoList";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

class CompetitionStageVoting extends Component {
  render() {

	if(!this.props.terms) return null;

    const videos = this.props.competitions[this.props.competitionId].videos;
    return (
      <div>

		<RichText content={this.props.terms.state_voting_open} />
        <VotingOpenHeader showText competitionId={this.props.competitionId} />
        <FilterableVideoList
          title={this.props.title}
          videos={videos}
          competitionSlug={
            this.props.competitions[this.props.competitionId].url
          }
        />
      </div>
    );
  }
}

export default withPrismic(withFirebase(CompetitionStageVoting));



// WEBPACK FOOTER //
// ./src/pages/Competition/CompetitionStageVoting.js